import { CASSEMS_WA_DUVIDAS_E164 } from '../content/cassemsLandingCopy';
import type { CassemsCartLine, CassemsCartTotals } from '../contexts/CassemsCartContext';

/** Nesta campanha o pagamento é sempre combinado com a equipe (sem InfinitePay online). */
export type CassemsPreferenciaPagamento = 'equipe_lunins';

type ClienteResumo = { nome: string; telefone: string; cpf: string; endereco: string; setor: string };

const WA_MAX = 2200;

function labelPagamento(_p: CassemsPreferenciaPagamento): string {
  return 'Pagamento a combinar com a equipe Lunins (horários flexíveis, inclusive na entrega — sem link online nesta campanha)';
}

/** Texto para o cliente colar no WhatsApp do Demétrio se a notificação automática falhar. */
export function textoWhatsappResumoPedidoCassems(
  cliente: ClienteResumo,
  lines: CassemsCartLine[],
  totais: CassemsCartTotals,
  preferenciaPagamento: CassemsPreferenciaPagamento
): string {
  const itens = lines
    .map((l) => `• ${l.nome} × ${l.quantidade} — R$ ${(l.precoUnitComDesconto * l.quantidade).toFixed(2).replace('.', ',')}`)
    .join('\n');
  let s =
    `Olá, Demétrio! Envio o resumo da minha encomenda Lunins (Cassems — ação de bem-estar).\n\n` +
    `*${labelPagamento(preferenciaPagamento)}*\n\n` +
    `*Meus dados (NF-e / garantia)*\n` +
    `Nome: ${cliente.nome}\n` +
    `Telefone: ${cliente.telefone}\n` +
    `CPF: ${cliente.cpf}\n` +
    `Setor / área de trabalho: ${cliente.setor || '—'}\n` +
    `Endereço: ${cliente.endereco}\n\n` +
    `*Itens*\n${itens}\n\n` +
    `*Total estimado:* R$ ${totais.subtotalComDesconto.toFixed(2).replace('.', ',')}\n` +
    `(Referência tabela R$ ${totais.subtotalCheio.toFixed(2).replace('.', ',')}; preços promocionais da página${totais.valorDescontoCombo > 0 ? `; combo especial −R$ ${totais.valorDescontoCombo.toFixed(2).replace('.', ',')}` : ''}.)`;
  if (s.length > WA_MAX) {
    s = s.slice(0, WA_MAX - 20) + '\n…(mensagem cortada)';
  }
  return s;
}

export function hrefWhatsappPedidoCassems(
  cliente: ClienteResumo,
  lines: CassemsCartLine[],
  totais: CassemsCartTotals,
  preferenciaPagamento: CassemsPreferenciaPagamento
): string {
  const text = textoWhatsappResumoPedidoCassems(cliente, lines, totais, preferenciaPagamento);
  return `https://wa.me/${CASSEMS_WA_DUVIDAS_E164}?text=${encodeURIComponent(text)}`;
}
